export const ALERTS_CHAT = {
  ADD_MESSAGE: 'ADD_MESSAGE',
  ADD_CHAT_ID: 'ADD_CHAT_ID',
  INIT_CHAT: 'INIT_CHAT',
  PROPOSE_CHAT: 'PROPOSE_CHAT',
  RESET_CHAT: 'RESET_CHAT',
  SET_ALERT_VIEW: 'SET_ALERT_VIEW',
};
